import React from 'react';

function getAclAction(assessment, category, actions, question, categoryAclAction) {
  let aclActionType;

  if (category) {
    const categoryActions = actions?.sectionActions?.filter(section => section.id === category.id);
    const categoryAclAction = categoryActions && categoryActions.length > 0 ? categoryActions[0].acl_action : '';
    aclActionType = categoryAclAction;
    if (categoryAclAction === 'Display' || categoryAclAction === 'ForceDisplay' || categoryAclAction === '') {
      const categoryFields = assessment?.fields?.filter(field => field.categoryId === category.id);
      const hiddenFields = categoryFields?.filter(x => actions?.fieldActions?.some(y => y.id === x.id && y.acl_action === 'Hide'));
      const areAllFieldsHidden = hiddenFields?.length === categoryFields?.length;
      if (areAllFieldsHidden) {
        aclActionType = 'Hide';
      }
    }
  } else if (question) {
    const getHiddenFields = actions?.filter(field => field.id === question.id);
    const fieldAclAction = getHiddenFields && getHiddenFields.length > 0 ? getHiddenFields[0].acl_action : '';
    // Field Actions are honoured only if the Category Action is set to Display.
    const applicableFieldAction =
      categoryAclAction === 'ForceDisplay' || categoryAclAction === 'Display' || categoryAclAction === '' ? fieldAclAction : categoryAclAction;
    aclActionType = applicableFieldAction;
  }
  return aclActionType;
}

function getFvlAction(question, fieldActions) {
  let fvlAction = [];
  if (question) {
    const availableAction = fieldActions?.filter(field => field.id === question.id);
    fvlAction = availableAction && availableAction.length > 0 ? availableAction[0].filter_values : [];
  }
  return fvlAction;
}

function getSetDateAction(question, fieldActions) {
  let setDateAction = '';
  if (question && fieldActions) {
    const availableAction = fieldActions?.filter(field => field.id === question.id && field.set_date);
    setDateAction = availableAction && availableAction.length > 0 ? availableAction[0].set_date.value : '';
  }
  return setDateAction;
}

function getSVLAction(question, fieldActions) {
  let SVLAction = [];
  if (question && fieldActions) {
    const availableAction = fieldActions?.filter(field => field.id === question.id);
    SVLAction = availableAction && availableAction.length > 0 ? availableAction[0].select_values : [];
  }
  return SVLAction;
}

export const ActionsHOC = WrappedComponent => props => {
  const { assessment, category, actions, question, categoryAclAction } = props;
  return (
    <WrappedComponent
      {...props}
      aclAction={getAclAction(assessment, category, actions, question, categoryAclAction)}
      fvlAction={getFvlAction(question, actions)}
      setDateAction={getSetDateAction(question, actions)}
      SVLAction={getSVLAction(question, actions)}
    />
  );
};

export default ActionsHOC;
